module.exports = __webpack_public_path__ + "img/no-photo.3708994b.jpg";